import { EException } from 'types/response-code/mkt';

export const mktErrorMessageInfo: Record<EException, string> = {
  '100': 'Có lỗi từ Sapo',
  '101': 'Không thể chỉnh sửa ở chế độ test',
  '102': 'Không đủ số lượng sản phẩm yêu cầu cho 1 combo',
  '103': 'Không tìm thấy sản phẩm',
  '-1': 'Vui lòng kiểm tra lại thông tin'
};
